export const PATIENT_INSURANCE_PRIORITY_CHOICES = {
    PRIMARY: 'Primary',
    SECONDARY: 'Secondary',
    OTHER_PRIMARY: 'Other Primary',
};
